module.exports = __webpack_public_path__ + "static/media/logo_qualdo-drx-light.fcc8069c.svg";